/**
 * Elegance Designs Studio — sticky Add to Cart bar
 * Slides up from the bottom of product pages once the main ATC button
 * scrolls out of the viewport.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const mainBtn = document.querySelector('[name="add"]');
    const productTitle =
      document.querySelector('.product__title h1') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1.title');
    const priceEl =
      document.querySelector('.price .price-item--regular') ||
      document.querySelector('.price__regular .price-item');

    if (!mainBtn || !productTitle) return;

    const bar = document.createElement('div');
    bar.className = 'sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<span class="sticky-atc__title">' +
        productTitle.textContent.trim() +
      '</span>' +
      '<span class="sticky-atc__price">' +
        (priceEl ? priceEl.textContent.trim() : '') +
      '</span>' +
      '<button class="sticky-atc__btn" aria-label="Add to cart">Add to Cart</button>';

    document.body.appendChild(bar);

    bar.querySelector('.sticky-atc__btn').addEventListener('click', function () {
      mainBtn.click();
    });

    const observer = new IntersectionObserver(function (entries) {
      const isMainVisible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !isMainVisible);
      bar.setAttribute('aria-hidden', String(isMainVisible));
    }, { threshold: 0 });

    observer.observe(mainBtn);
  });
}());
